import chroma from 'chroma-js';
import {
  newPalette,
  pastPerformancePalette,
  policyColors,
  adviserCharges
} from 'components/Charts/Utils';

export const paletteSettings = (theme?: any, riskProfiler?: any) => {
  const isEvalue = riskProfiler === 'Evalue';

  const riskAnalysisEvalue = {
    title: 'Risk analysis chart colours',
    subTitle:
      'Risk summary, forecast gross investment returns and risk score dial. The risk score dial uses the first and last colour in this colour set.',
    key: 'risk-analysis',
    default: newPalette,
    maxColours: 5,
    visible: isEvalue
  };

  const riskAnalysisMS = {
    title: 'Morningstar risk analysis charts',
    subTitle:
      'Risk tolerance bar and risk analysis charts. The risk tolerance bar uses the first and last colour in this colour set.',
    key: 'risk-analysis-ms',
    default: ['#B71F2A', '#F7B800', '#008F59'],
    maxColours: 3,
    visible: !isEvalue
  };

  const riskToleranceBarConfig = {
    title: 'Risk tolerance bar',
    subTitle: 'Morningstar-specific risk tolerance bar',
    key: 'risk-tolerance-bar',
    default: ['#BA4977', '#1B84AB'],
    maxColours: 2
  };

  return [
    {
      title: 'Theme colours',
      subTitle: 'Buttons, links and headings',
      key: 'theme',
      default: theme
        ? [theme.palette.primary.main, theme.palette.secondary.main]
        : undefined,
      maxColours: undefined
    },
    riskAnalysisEvalue,
    riskAnalysisMS,
    riskToleranceBarConfig,
    {
      title: 'Charting colours',
      subTitle: 'Performance and scatter charts',
      key: 'charting',
      default: pastPerformancePalette,
      maxColours: undefined
    },
    {
      title: 'Comparison colours',
      subTitle: 'Existing vs Recommended, Equity vs Fixed income',
      key: 'comparisons',
      default: [policyColors.existing, policyColors.recommended],
      maxColours: undefined
    },
    {
      title: 'Breakdown colours',
      subTitle: 'Asset class and sector',
      key: 'asset-allocation',
      default: newPalette,
      maxColours: undefined
    },
    {
      title: 'Cost and charges chart colours',
      key: 'adviser-charges',
      default: [
        adviserCharges.net_value,
        adviserCharges.advisor_charges,
        adviserCharges.product_charges,
        adviserCharges.annualised_withdrawals,
        adviserCharges.annualised_contributions
      ],
      maxColours: undefined
    }
  ];
};

export const existingVsRecommendedIndex = (type: any) => {
  return type == 'existing' ? 0 : 1;
};

export const equityVsFixedIncomeIndex = (type: any) => {
  return type == 'equity' ? 0 : 1;
};

export const adviserChargesIndex = (type: any) => {
  return Object.keys(adviserCharges).indexOf(type);
};

export const gradientColors = (theme: any, riskGroup: any = 10) => {
  const riskAnalysisColours = theme.palette.baseColors.charts['risk-analysis'];
  const lastIndex = riskAnalysisColours[4] ? 4 : riskAnalysisColours.length - 1;
  const lastColor = riskAnalysisColours[lastIndex];
  return chroma
    .scale([
      theme.palette.baseColors.charts['risk-analysis'][0],
      chroma.mix(
        theme.palette.baseColors.charts['risk-analysis'][0],
        lastColor,
        0.5
      ),
      lastColor
    ])
    .colors(riskGroup);
};
